var map = {
	"./0.mp3": 9628,
	"./1.mp3": 4929,
	"./2.mp3": 5474,
	"./3.mp3": 5797,
	"./4.mp3": 7042,
	"./5.mp3": 8048,
	"./6.mp3": 2751,
	"./7.mp3": 1995,
	"./8.mp3": 5559,
	"./9.mp3": 8050,
	"./bgm.mp3": 7512,
	"./eatsound.mp3": 8766,
	"./endbell.mp3": 1258,
	"./fault.mp3": 5021,
	"./hitsound1.mp3": 4662,
	"./hitsound2.mp3": 2947,
	"./timer.mp3": 1450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1678;